// extracted by mini-css-extract-plugin
module.exports = {"roomSkeleton":"RoomSkeleton_roomSkeleton__TCmMb"};